'use strict';

const Enum = require('./enum');

/**
 * Defines system users.
 *
 * @enum
 * @readonly
 */
module.exports.SystemUsers = Object.create(Enum, {
  ANY_USER: { value: 'anyuser', enumerable: true },
  ANY_SUPER_USER: { value: 'anysuperuser', enumerable: true },
  NOT_SUPER_USER: { value: 'notsuperuser', enumerable: true },
  YALE_USER: { value: 'yaleuser', enumerable: true },
  MANUAL_LOCK: { value: 'manuallock', enumerable: true },
  MANUAL_UNLOCK: { value: 'manualunlock', enumerable: true },
  AUTO_RELOCK: { value: 'autorelock', enumerable: true },
  RBS_LOCK_COMMAND: { value: 'rbs_lock_command', enumerable: true },
  ZWAVE_LOCK_COMMAND: { value: 'zwave_lock_command', enumerable: true },
  DOOR_OPEN: { value: 'door_open', enumerable: true },
  DOOR_CLOSED: { value: 'door_closed', enumerable: true },
  ONE_TOUCH_LOCK: { value: 'onetouchlock', enumerable: true },
  MASTER_PIN: { value: 'masterpin', enumerable: true },
  ORCHESTRA_SERVICE_AGENT_USER: { value: 'orchestra_service_agent', enumerable: true },
  LOW_BAT_AUTO_UNLOCK: { value: 'lowbatautounlock', enumerable: true },
  INSIDE_BUTTON_LOCK: { value: 'inside_button_lock', enumerable: true },
  INSIDE_BUTTON_UNLOCK: { value: 'inside_button_unlock', enumerable: true },
  ESCAPE_UNLOCK: { value: 'escapeunlock', enumerable: true },
});

/**
 * Defines user types.
 *
 * @enum
 * @readonly
 */
module.exports.UserTypes = Object.create(Enum, {
  SUPER_USER: { value: 'superuser', enumerable: true },
  MANAGER: { value: 'manager', enumerable: true },
  LIMITED: { value: 'limited', enumerable: true },
  USER: { value: 'user', enumerable: true },
  UNVERIFIED: { value: 'unverified', enumerable: true },
});

/**
 * Defines an unknown user.
 */
module.exports.UnknownUser = {
  UserID: 'deleted',
  FirstName: 'Unknown',
  LastName: 'User',
  UserName: 'deleteduser',
  PhoneNo: 'deleted',
};

module.exports.UserNotificationTypes = Object.create(Enum, {
  LOCK_MEMBERSHIP: { value: 'lockmembership', enumerable: true },
  CONFIGURATION: { value: 'configuration', enumerable: true },
  LIFECYCLE: { value: 'lifecycle', enumerable: true },
});

/**
 * Defines user download statuses.
 *
 * @enum
 * @readonly
 */
module.exports.UserDownloadStatuses = Object.create(Enum, {
  REQUESTED: { value: 'Requested', enumerable: true },
  PROCESSING: { value: 'Processing', enumerable: true },
  AVAILABLE: { value: 'Available', enumerable: true },
  FAILED: { value: 'Failed', enumerable: true },
  DELETED: { value: 'Deleted', enumerable: true },
});

module.exports.i18nDefaults = Object.create(Enum, {
  languageCode: { value: 'en', enumerable: true },
  countryCode: { value: 'US', enumerable: true },
});

/**
 * Defines user factory reset request statuses.
 *
 * @enum
 * @readonly
 */
module.exports.UserFactoryResetRequestStatuses = Object.create(Enum, {
  APPROVED: { value: 'approved', enumerable: true },
  PENDING: { value: 'pending', enumerable: true },
  DENIED: { value: 'denied', enumerable: true },
});
